module.exports = __webpack_public_path__ + "static/img/sec 06.3d959ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 06.png
// module id = Us3P
// module chunks = 12